import React from 'react';
import PropTypes from 'prop-types';
import RenderLocalisationInputField from 'components/form/InputFields/RenderLocalisationInputField';
import RenderPropertyGroupsInputField from 'components/form/InputFields/AutoCompleteField/RenderPropertyGroupsInputField';
import SubmitButton from 'components/button/SubmitButton';
import compose from 'recompose/compose';
import translate from 'components/hoc/translate';
import validations from 'helpers/forms/validations';
import { ButtonWrapper, FormWrapper, Item, Row, Section } from 'components/ui/table/elements';
import { connect } from 'react-redux';
import { reduxForm, isInvalid, Field } from 'redux-form';

class PropertiesEditForm extends React.Component {
    constructor(props) {
        super(props);

        const {
            data,
            initialize,
            localisation,
        } = props;

        initialize({
            property_group_id: data.property_group_id,
            localisation: localisation,
        });
    }

    render() {
        const {
            form,
            handleSubmit,
            handleSubmitForm,
            invalid,
            localisation,
            localisationFields,
            pristine,
            submitting,
        } = this.props;

        return (
            <FormWrapper>
                <form onSubmit={ handleSubmit(handleSubmitForm) }>
                    <Section>
                        <Row>
                            <Item>
                                <Field
                                    component={ RenderPropertyGroupsInputField }
                                    fullWidth={ true }
                                    label={ 'resources.properties.fields.property_group_id' }
                                    name='property_group_id'
                                    validate={ validations.required }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <Item>
                                <RenderLocalisationInputField
                                    localisation={ localisation }
                                    fields={ localisationFields }
                                    form={ form }
                                />
                            </Item>
                        </Row>
                    </Section>

                    <Section>
                        <Row>
                            <ButtonWrapper>
                                <SubmitButton
                                    disabled={ pristine || submitting || invalid }
                                    loading={ submitting }
                                />
                            </ButtonWrapper>
                        </Row>
                    </Section>
                </form>
            </FormWrapper>
        );
    }
}

PropertiesEditForm.defaultProps = {
    localisationFields: [
        {
            maxLength: 255,
            name: 'name',
            required: true,
            type: 'text',
        },
        {
            maxLength: 325,
            name: 'description',
            required: true,
            type: 'textarea',
        },
    ],
};

PropertiesEditForm.propTypes = {
    data: PropTypes.object,
    form: PropTypes.string,
    handleSubmit: PropTypes.func.isRequired,
    handleSubmitForm: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    invalid: PropTypes.bool,
    localisation: PropTypes.object,
    localisationFields: PropTypes.array,
    pristine: PropTypes.bool,
    submitting: PropTypes.bool,
};

const mapStateToProps = (state, props) => {
    const {
        form,
    } = props;

    return {
        invalid: isInvalid(form)(state),
    };
};

const enhance = compose(
    translate,
    connect(
        mapStateToProps,
        null,
    ),
    reduxForm({
        validate: (values, props) => {
            const errors = {};
            const { translate } = props;

            if (!values.property_group_id) {
                errors.property_group_id = translate('forms.required');
            }

            return errors;
        },
    }),
);

export default enhance(PropertiesEditForm);



// WEBPACK FOOTER //
// ./src/pages/properties/edit/PropertiesEditForm.js